var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Directive, Input, Optional, Host } from "@angular/core";
import { NgControl } from '@angular/forms';
import { ControlContainer } from "@angular/forms";
var DisableControlDirective = /** @class */ (function () {
    function DisableControlDirective(ngControl, controlContainer) {
        this.ngControl = ngControl;
        this.controlContainer = controlContainer;
        // debugger
    }
    Object.defineProperty(DisableControlDirective.prototype, "disableControl", {
        set: function (condition) {
            var _this = this;
            setTimeout(function () {
                var action = condition ? 'disable' : 'enable';
                if (_this.ngControl) {
                    _this.ngControl.control[action]();
                }
                if (_this.controlContainer) {
                    _this.controlContainer.control[action]();
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], DisableControlDirective.prototype, "disableControl", null);
    DisableControlDirective = __decorate([
        Directive({
            selector: '[disableControl]'
        }),
        __param(0, Optional()), __param(0, Host()), __param(1, Optional()), __param(1, Host()),
        __metadata("design:paramtypes", [NgControl, ControlContainer])
    ], DisableControlDirective);
    return DisableControlDirective;
}());
export { DisableControlDirective };
//# sourceMappingURL=disable-control.directive .js.map